import script from "./BrandsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandsSlider.vue?vue&type=script&setup=true&lang=js"

import "./BrandsSlider.vue?vue&type=style&index=0&id=ab3ad590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab3ad590"]])

export default __exports__